import React from 'react';
import { AddToCalendarButton } from 'add-to-calendar-button-react';

function Home({ currLang }) {
  return (
    <div style={{ textAlign: "center", marginTop: "2rem" }}>
      <img
        src="/gallery/000537220004.jpg" // Change this path to your preferred image
        alt="Home"
        style={{ maxWidth: "90vw", maxHeight: "80vh", borderRadius: "12px" }}
      />
      <div style={{ marginTop: "1.5rem", fontSize: "2.5rem", fontWeight: "bold", marginBottom: "0.5rem" }}>
        <div>
          {currLang === "IS" ?
            "18. júlí 2026"
            :
            "18. July 2026"
          }
        </div>
        <div style={({ marginTop: "0.5rem", fontSize: "2rem" })}>
          Eskifjörður
        </div>
      </div>
      {currLang === "IS" ? "Fleiri upplýsingar koma síðar." : "More information will come later."}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "2rem", marginBottom: "2rem" }}>

        <AddToCalendarButton
          name={currLang === "IS" ? "Magnea og Ásbjörn - Gifting" : "Magnea and Ásbjörn - Wedding"}
          description={currLang === "IS" ? "Hlökkum til að sjá þig á Eskifirði!" : "We look forward to seeing you in Eskifjörður!"}
          startDate="2026-07-17"
          startTime="12:00"
          endDate="2026-07-19"
          endTime="03:00"
          timeZone="Iceland"
          location="Eskifjörður"
          organizer="Magnea og Ásbjörn|bryllup@edvaldsson.is"
          availability="busy"
          iCalFileName="MagneaÁsbjörnBryllup"
          options="'Apple','Google','iCal','Outlook.com'"
          size="9"
          label={currLang === "IS" ? "Bæta við í dagatal" : "Add to calendar"}
          lightMode="system"
          pastDateHandling="disable"
        ></AddToCalendarButton>
      </div>
    </div>
  );
}

export default Home;
